export const siteEngagementTooltipIds = {
  STATUS_TOOLTIP_ID: 'status-tooltip',
  SORT_TOOLTIP_ID: 'sort-tooltip',
  LONG_TEXT_TOOLTIP_ID: 'long-text-tooltip',
};
